/**
 * Created by baird on 2016/12/30.
 */
export default {
    state: {
        softType: 2,//1.儿保，2.妇保
    },
   
    getters: {
        softType: state => {
            return state.softType;
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/system.js